module.exports = __webpack_public_path__ + "6bc1a2144e580983ff9583fdcac6f002.jpg";